// Add-ons activos por REGALO del administrador (UserAddOnGrant).
//
// `activeAddOnNames` (GET addOn/ActiveIds) = contratados + regalados; los
// contratados son los `userAddOns` con cantidad > 0. Un regalado cuenta como
// activo a todos los efectos: no se ofrece para comprar ni se pide contratarlo.
// Se compara por nombre: cada add-on tiene un hermano mensual/anual con otro id.

const norm = (s) => (s || "").trim().toLowerCase();

/** Nombres (normalizados) de los add-ons contratados y vigentes. */
export function contractedAddOnNames(userAddOns = [], addOnsById = {}) {
  return new Set(
    (userAddOns || [])
      .filter((u) => (u.quantity || 0) > 0 && u.isActive !== false)
      .map((u) => norm(addOnsById[u.idAddOn]?.name))
      .filter(Boolean),
  );
}

/** Nombres (normalizados) de los add-ons activos solo por regalo. */
export function giftedAddOnNames(activeAddOnNames = [], userAddOns = [], addOnsById = {}) {
  const contracted = contractedAddOnNames(userAddOns, addOnsById);
  return new Set((activeAddOnNames || []).map(norm).filter((n) => n && !contracted.has(n)));
}

/** ¿El add-on de ese nombre está activo (contratado o regalado)? */
export function isAddOnActive(name, { activeAddOnNames = [], userAddOns = [], addOnsById = {} } = {}) {
  const n = norm(name);
  if (!n) return false;
  return (activeAddOnNames || []).some((a) => norm(a) === n) || contractedAddOnNames(userAddOns, addOnsById).has(n);
}

export const isGifted = (addOn, giftedNames) => !!addOn && giftedNames.has(norm(addOn.name));
